class NewReadMore extends HTMLElement {
  constructor() {
    super()

    this.trigger = this
    this.contractedParent = document.querySelector('.clc-Hero_Text--contracted')
    this.expandedParent = document.querySelector('.clc-Hero_Text--expanded')
    this.contracted = document.querySelector('.clc-Hero_Text--contracted .clc-Hero_ReadMore')
    this.expanded = document.querySelector('.clc-Hero_Text--expanded .clc-Hero_ReadMore')
    this.initialiseReadMoreDesc()

  }

  initialiseReadMoreDesc() {
    this.contracted.addEventListener('click', () => {
      this.contractedParent.classList.remove('clc-Hero_Text--active')
      this.expandedParent.classList.add('clc-Hero_Text--active')
    })

    this.expanded.addEventListener('click', () => {
      this.contractedParent.classList.add('clc-Hero_Text--active')
      this.expandedParent.classList.remove('clc-Hero_Text--active')
    })
  }

}

customElements.define('new-read-more', NewReadMore)